var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-box',{attrs:{"scrollable":"","title":"Партнерское соглашение","max-width":"80%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('policy-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }